import { useState } from 'react'

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Request } from 'commons/utils/request'

import { handlerServerError } from '@orbit/errors'

import { ContactMetadata } from '../types/contact'

export const useSaveContactMetadata = (onSuccess?: () => void) => {
  const queryClient = useQueryClient()
  const [isSuccess, setIsSuccess] = useState(false)

  const { mutateAsync: saveMetadata } = useMutation<ContactMetadata, Error, ContactMetadata & { isCreating: boolean }>({
    mutationFn: (opts) =>
      opts.isCreating
        ? Request.post(Request.urls.bank.contactCompanyConnection, opts)
        : Request.put(Request.urls.bank.contactCompanyConnection, opts),
    onSuccess: async (opts) => {
      setIsSuccess(true)
      if (opts.companyId) {
        queryClient.invalidateQueries({ queryKey: ['companyDetails', opts.companyId] })
      }
      if (onSuccess) {
        onSuccess()
      }
    },
    onError: (error) => {
      handlerServerError(error)
    }
  })

  return {
    saveMetadata,
    isSuccess
  }
}
